import { render, staticRenderFns } from "./UiMotionList.vue?vue&type=template&id=1f677d93"
import script from "./UiMotionList.vue?vue&type=script&lang=js"
export * from "./UiMotionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports